define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../models/UserContext", "../../models/CustomerTypeModel"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, UserContext, CustomerTypeModel) {
    "use strict";
    var CustomerTypes = /** @class */ (function () {
        function CustomerTypes() {
            this.userCanEditCustomerType = ko.observable(UserContext.hasAccess("Admin,CustomerType.Edit,CustomerType.Delete"));
            this.userCanDeleteCustomerType = ko.observable(UserContext.hasAccess("Admin,CustomerType.Delete"));
            this.filterByAny = ko.observable("");
            this.editModel = ko.observable(new CustomerTypeModel());
        }
        CustomerTypes.prototype.init = function () {
            var self = this;
            $("#page-title").text("Customer Service Types");
            tools.ajaxGet({
                url: "/CustomerType/GetLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.suppliersLookupList = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initGrid(self.suppliersLookupList.GridStructures.CustomerTypesStructure);
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        CustomerTypes.prototype.initGrid = function (gridStructure) {
            var self = this;
            var gridId = "tblCustomerTypesKendo";
            var columns = gridStructure.columns;
            //add actions column
            var actions = {
                field: "",
                width: "100px",
                template: function (dataItem) {
                    var html = "";
                    if (self.userCanEditCustomerType()) {
                        html += '<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit "></i></a>';
                    }
                    if (self.userCanDeleteCustomerType()) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            };
            columns.push(actions);
            self.suppliersTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/CustomerType/GetCustomerTypes",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#customer-types-toolbar-template").html()),
                    columns: columns
                },
                gridId: gridId,
                showPagerOnTop: false,
                enableExport: {
                    entityName: "CustomerType",
                    title: "Customer Types",
                    enablePdf: false
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.suppliersTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.suppliersTable.getGridData().dataSource.read();
            });
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.editCustomerType(data.Id);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.deleteCustomerTypeConfirm(data.Id, data.Name);
                event.preventDefault();
            });
        };
        CustomerTypes.prototype.editCustomerType = function (id) {
            var self = this;
            var title = "Add New Customer Type";
            if (!isNaN(id)) {
                title = "Edit Customer Type";
            }
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editModel().Name()) {
                        tools.error("Customer Type Name is a required field");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveCustomerType(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(id)) {
                        getModelCall = tools.ajaxGet({
                            url: "/CustomerType/GetCustomerTypeById",
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new CustomerTypeModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new CustomerTypeModel());
                    }
                    $.when(getModelCall).done(function (data) {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'customer-type-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                        //log.log(parentDropDown);
                    });
                }
            });
        };
        CustomerTypes.prototype.saveCustomerType = function (btn, modal) {
            var self = this;
            var data = tools.modelToFormData(self.editModel());
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerType/SaveCustomerType",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    self.suppliersTable.refresh();
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CustomerTypes.prototype.deleteCustomerType = function (id) {
            var self = this;
            var data = {
                id: id
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerType/DeleteCustomerTypeConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("CustomerType deleted successfully");
                    self.suppliersTable.refresh();
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        CustomerTypes.prototype.deleteCustomerTypeConfirm = function (id, name) {
            var self = this;
            tools.confirmModal({
                title: "Delete Customer Type",
                text: "Are you sure you want to delete Customer Type " + name + "?",
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deleteCustomerType(id);
            });
        };
        return CustomerTypes;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/CustomerType/Index")) {
            log.log("Initialize CustomerTypes list");
            $(function () {
                (new CustomerTypes()).init();
            });
        }
    }, 0);
    return CustomerTypes;
});
//# sourceMappingURL=customerTypes.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/settings/customerTypes.js
// module id = 236
// module chunks = 2